import { useFreshRef } from "./useFreshRef";
function useFreshTick(callback) {
    var freshRef = useFreshRef(callback);
    function tick() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (typeof freshRef.current === "function") {
            freshRef.current.apply(freshRef, args);
        }
    }
    return tick;
}
export { useFreshTick };
